"use client";

import Image from "next/image";
import { buildContentstackImageUrl } from "@/lib/utils";

const LearnMoreModal = ({ image, productTitle, description }) => {
  return (
    <div className="flex flex-col lg:flex-row p-6 lg:p-18 font-sans text-primary">
      {image?.url && (
        <div className="w-full lg:w-1/2 flex items-center justify-center lg:justify-start">
          <Image
            src={buildContentstackImageUrl(image.url, 600)}
            width={600}
            height={600}
            className="max-w-[300px] max-h-[300px] object-cover aspect-square"
            sizes="300px"
            alt={image?.description || image?.title || productTitle || ""}
          />
        </div>
      )}

      <div className="w-full text-left mt-10 lg:mt-0 lg:w-1/2">
        <h3 className="text-2xl font-light mb-5 leading-10">
          {productTitle}
        </h3>
        {description && (
          <div
            className="text-lg font-normal leading-7 rte-content"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  );
};

export default LearnMoreModal;
